import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';
import DemoBanner from './components/DemoBanner';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import JobDetailsPage from './pages/JobDetailsPage';
import CreateJobPage from './pages/CreateJobPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PrivacyPage from './pages/PrivacyPage';
import SearchPage from './pages/SearchPage';
import MessagesPage from './pages/MessagesPage';
import EditProfilePage from './pages/EditProfilePage';
import SettingsPage from './pages/SettingsPage';
import EditJobPage from './pages/EditJobPage';

/**
 * Demo App - Standalone demo version of Minitask
 * Always runs in demo mode with mock data
 */
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-slate-50">
          <DemoBanner />
          <Header />
          
          {/* Main content - padding bottom for mobile bottom nav */}
          <main className="flex-grow pb-20 md:pb-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/sok" element={<SearchPage />} />
              <Route path="/profil/rediger" element={<EditProfilePage />} />
              <Route path="/profil/:id" element={<ProfilePage />} />
              <Route path="/innstillinger" element={<SettingsPage />} />
              <Route path="/annonse/:id" element={<JobDetailsPage />} />
              <Route path="/opprett-annonse" element={<CreateJobPage />} />
              <Route path="/rediger-annonse/:id" element={<EditJobPage />} />
              <Route path="/logg-inn" element={<LoginPage />} />
              <Route path="/registrer" element={<RegisterPage />} />
              <Route path="/personvern" element={<PrivacyPage />} />
              <Route path="/meldinger" element={<MessagesPage />} />
            </Routes>
          </main>
          
          {/* Footer - Only visible on desktop */}
          <div className="hidden md:block">
            <Footer />
          </div>
          
          {/* Mobile-only components */}
          <BottomNav />
          
          {/* Cookie consent banner */}
          <CookieBanner />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
